import { db } from '../instant';
import { id } from '@instantdb/react';
import { StorageLocation } from '../schema';

/**
 * Create a new storage location
 */
export async function createStorageLocation(params: { name: string; order?: number }): Promise<string> {
    const locationId = id();
    await db.transact(
        db.tx.storageLocations[locationId].update({
            name: params.name,
            order: params.order ?? 0,
        })
    );
    return locationId;
}

/**
 * Update a storage location
 */
export async function updateStorageLocation(locationId: string, updates: { name?: string; order?: number }): Promise<void> {
    await db.transact(db.tx.storageLocations[locationId].update(updates));
}

/**
 * Check if a storage location can be deleted (no itemLocations reference it)
 */
export function canDeleteStorageLocation(
    locationId: string,
    itemLocationsWithStorage: Array<{ storageLocation?: { id: string } | null }>
): { canDelete: boolean; reason?: string } {
    const hasItemLocations = itemLocationsWithStorage.some(loc => loc.storageLocation?.id === locationId);
    if (hasItemLocations) {
        return { canDelete: false, reason: 'Cannot delete: inventory exists at this location' };
    }
    return { canDelete: true };
}

/**
 * Delete a storage location
 */
export async function deleteStorageLocation(location: StorageLocation): Promise<void> {
    await db.transact(db.tx.storageLocations[location.id].delete());
}
